import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../config';
import VisitorChatsPanel from './VisitorChatsPanel';
import LineCollaboratorsPanel from './LineCollaboratorsPanel';

const AgentPortal = () => {
  const [loggedIn, setLoggedIn] = useState(() => !!localStorage.getItem('agentSession'));
  const [agentName, setAgentName] = useState(() => localStorage.getItem('agentName') || '');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCollabs, setShowCollabs] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/agent/login`, { username: username.trim(), password });
      localStorage.setItem('partnerToken', data.access_token);
      localStorage.setItem('agentSession', '1');
      localStorage.setItem('agentName', data.user?.name || username);
      setAgentName(data.user?.name || username);
      setLoggedIn(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Σφάλμα σύνδεσης');
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('partnerToken');
    localStorage.removeItem('agentSession');
    localStorage.removeItem('agentName');
    setLoggedIn(false); setUsername(''); setPassword('');
  };

  if (loggedIn) {
    return (
      <div className="min-h-screen" style={{ background: 'radial-gradient(circle at 50% 0%, #12233f 0%, #0a1628 60%)' }}>
        <div className="flex items-center justify-between px-4 md:px-8 py-4 border-b border-gold/20">
          <div className="flex items-center gap-3">
            <button onClick={() => { window.location.href = '/'; }} className="mr-1 w-9 h-9 rounded-full border border-gold/50 text-gold flex items-center justify-center hover:bg-gold/10 transition flex-shrink-0" data-testid="agent-back-btn" aria-label="Επιστροφή" title="Επιστροφή στην ιστοσελίδα">
              ←
            </button>
            <img src="/patient-line-icon.png" alt="" className="w-10 h-10 rounded-full" />
            <div>
              <p className="text-gold font-bold text-sm" style={{ fontFamily: 'Georgia, serif' }}>Πύλη Αντιπροσώπου</p>
              <p className="text-slate-400 text-xs" data-testid="agent-name">{agentName}</p>
            </div>
          </div>
          <button onClick={logout} className="px-4 py-2 rounded-lg text-sm text-gold border border-gold/50 hover:bg-gold/10 transition" data-testid="agent-logout-btn">
            Αποσύνδεση
          </button>
        </div>
        <div className="px-4 md:px-8 pt-4 flex justify-end">
          <button
            onClick={() => setShowCollabs(true)}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-navy"
            style={{ background: 'linear-gradient(180deg,#d4b661,#a17f2f)' }}
            data-testid="agent-view-collaborators-btn"
          >
            📋 Διαθέσιμοι Συνεργάτες
          </button>
        </div>
        <div className="p-3 md:p-6">
          <VisitorChatsPanel />
        </div>

        {showCollabs && (
          <div className="fixed inset-0 z-[10000] bg-black/70 backdrop-blur-sm flex items-start justify-center p-4 overflow-y-auto" onClick={() => setShowCollabs(false)} data-testid="collaborators-modal-overlay">
            <div onClick={(e) => e.stopPropagation()} className="relative w-full max-w-4xl my-8">
              <button
                onClick={() => setShowCollabs(false)}
                className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-navy border border-gold/50 text-gold flex items-center justify-center hover:bg-gold/10 z-10"
                data-testid="collaborators-modal-close"
                aria-label="Close"
              >
                ✕
              </button>
              <LineCollaboratorsPanel readOnly />
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'radial-gradient(circle at 50% 0%, #12233f 0%, #0a1628 60%)' }}>
      <button onClick={() => { window.location.href = '/'; }} className="fixed top-5 left-5 inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm text-gold border border-gold/50 hover:bg-gold/10 transition" data-testid="agent-login-back-btn">
        ← Επιστροφή στην ιστοσελίδα
      </button>
      <form onSubmit={login} className="w-full max-w-sm rounded-2xl p-8" style={{ background: 'rgba(12,22,40,0.9)', border: '1px solid rgba(201,168,76,0.4)' }} data-testid="agent-login-form">
        <div className="flex flex-col items-center mb-6">
          <img src="/patient-line-icon.png" alt="" className="w-16 h-16 rounded-full mb-3" />
          <h1 className="text-white text-xl font-bold" style={{ fontFamily: 'Georgia, serif' }}>Πύλη Αντιπροσώπου</h1>
        </div>
        {error && <p className="text-red-400 text-sm text-center mb-3" data-testid="agent-login-error">{error}</p>}
        <label className="block text-slate-300 text-xs mb-1">Username</label>
        <input value={username} onChange={(e) => setUsername(e.target.value)} className="w-full mb-3 px-3 py-2.5 rounded-lg bg-navy-200/60 border border-slate-700 text-white text-sm focus:border-gold outline-none" data-testid="agent-username-input" autoComplete="username" />
        <label className="block text-slate-300 text-xs mb-1">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mb-5 px-3 py-2.5 rounded-lg bg-navy-200/60 border border-slate-700 text-white text-sm focus:border-gold outline-none" data-testid="agent-password-input" autoComplete="current-password" />
        <button type="submit" disabled={loading} className="w-full py-3 rounded-lg font-bold text-navy uppercase tracking-wide disabled:opacity-60" style={{ background: 'linear-gradient(180deg,#d4b661,#a17f2f)', fontFamily: 'Georgia, serif' }} data-testid="agent-login-submit">
          {loading ? '...' : 'Σύνδεση'}
        </button>
      </form>
    </div>
  );
};

export default AgentPortal;
